import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BE_API_URL} from '../constants/app.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  contactUs(name: string, email: string, phone: string, message: string, company: string): Observable<any> {
    return this.http.post(`${BE_API_URL}/contactUs`, { name, email, phone, message, company });
  }

  leadCapture(payload: {
    company: string;
    email: string;
    name?: string;
    propertiesCount?: number;
    trigger?: string;   // 'pricing_slider' | 'faq_click' | 'exit_intent' | 'features_done'
    mode?: string;      // 'emergency' | 'hospitality'
    language?: string;  // 'de' | 'en'
    consent?: boolean;
    ts?: string;
    website?: string;   // honeypot
  }): Observable<any> {
    return this.http.post(`${BE_API_URL}/leadCapture`, payload);
  }
}
